export default {
  'paymentAdditionalDetails.header': 'Additional Payment Details',
  'paymentAdditionalDetails.maxPerLine': 'Max 35 characters per line',
  'paymentAdditionalDetails.add2ndBank': 'Add 2nd Intermediary Bank',
  // sections
  'paymentAdditionalDetails.interBank': 'Bank',
  'paymentAdditionalDetails.originatorToBeneficiary': 'Originator to Beneficiary Information',
  'paymentAdditionalDetails.bankToBankInformation': 'Bank To Bank Information',

  // labels
  'paymentAdditionalDetails.bankCode': 'Bank Code / Name',
  'paymentAdditionalDetails.bankCodeType': 'Bank Code Type',
  'paymentAdditionalDetails.line': 'line <%=line%>',
  'paymentAdditionalDetails.bankOne': 'Bank 1',
  'paymentAdditionalDetails.bankTwo': 'Bank 2',

  // misc
  'paymentAdditionalDetails.international.panelTitle': 'Intermediary Bank'
};
